/// <amd-module name="Test/TestCaseResults/Redux/TelemetryActions" />
import { ActionsUnion, createAction, trackedAction, trackedErrorAction } from "redux/Utils/ActionHelper";

//TODO-TRACKING: salehahu - Merge this with telemetryActions in HubRefresh Page.
export const TelemetryActions = {
    publishTelemetry: (action: string, properties?: { [key: string]: any }) =>
        trackedAction(createAction(TelemetryActionTypes.publishTelemetry), { action, ...properties }),
    publishErrorTelemetry: (action: string, properties?: { [key: string]: any }) =>
        trackedErrorAction(createAction(TelemetryActionTypes.publishTelemetry, { action, ...properties }))
};

export const enum TelemetryActionTypes {
    publishTelemetry = "TestCaseResults"
}

export type TelemetryAction = ActionsUnion<typeof TelemetryActions>;
